import { apiClient } from './components/api/ApiClient.js';
import toast from "react-hot-toast";

apiClient.interceptors.request.use(
  config => {
    //const token = localStorage.getItem('accessToken'); 
    //if (token) {
    //  config.headers['Authorization'] = token;
    //}
    return config;
  },
  (error) => Promise.reject(error)
);

apiClient.interceptors.response.use(
  response => response,
  error => {
    const { response } = error;
    console.log("🛑 Interceptor Caught Error:", response || error.message);

    if (response) {
      switch (response.status) {
        case 401:
          toast.dismiss();
          toast.error("❌ 401 Unauthorized detected! Logging out...", { autoClose: 3000 });
          console.error("❌ 401 Unauthorized detected! Logging out...");
          /*setTimeout(() => {
            localStorage.removeItem("accessToken");
            window.location.href = "/authenticate";
          }, 2000);*/
          setTimeout(() => {
            window.location.href = "/authenticate"; // FRONTEND login route
          }, 1000);
          break;

        case 403:
          // Forbidden: user isn’t allowed to access this resource
          toast.dismiss();
          toast.error("Forbidden: you don’t have permission to view this page.", { autoClose: 5000 });
          console.warn("403 Forbidden");
          break;

        default:
          // other HTTP errors
          toast.dismiss();
          toast.error(`Error ${response.status}: ${response.statusText}`, { autoClose: 4000 });
          console.error(`HTTP ${response.status}`, response.data);
      }
    } else {
      // network / CORS / no response
      console.error("Network or CORS error:", error.message);
      toast.dismiss();
      toast.error("Network error. Please check your connection.", { autoClose: 4000 });
       /*setTimeout(() => {
            localStorage.removeItem("accessToken");
            window.location.href = "/authenticate";
          }, 2000);*/
       setTimeout(() => {
        window.location.href = "/authenticate";
      }, 1000);
    }

    return Promise.reject(error);
  }
);


export default apiClient;